import React from "react";
import PropTypes from 'prop-types';
import PromotedProduct from "./PromotedProduct";
import "./CtaSolution.scss";

export default function CtaSolution({data, productType, handlePromotedProduct}) {
  return (
    <div className="cta-solution-container">
      {data.map((c, i) => {
        if (c.isEnabled && c.productHost.toLowerCase() === productType.toLowerCase()) {
          return (
            <PromotedProduct
              key={i}
              icon={c.icon}
              hasBackgroundImage={c.hasBackgroundImage}
              backgroundImage={c.backgroundImage}
              title={c.title}
              subTitle={c.subTitle}
              buttonText={c.buttonText}
              ctaType={c.ctaType}
              redirectUri={c.redirectUri}
              filter={c.filter}
              isEnabled={c.isEnabled}
              handlePromotedProduct={handlePromotedProduct}
            />
          )
        }
      })}
    </div>
  );
}

CtaSolution.propTypes = {
  data: PropTypes.array.isRequired,
  productType: PropTypes.string.isRequired,
  handlePromotedProduct: PropTypes.func.isRequired
}




// WEBPACK FOOTER //
// ./src/components/Quoters/Common/CtaSolution/CtaSolution.js